import axios from "axios";

import { SERVER_URL } from "api/constants";
import getHeader from "api/getHeader";
import Goods from "store/productPayment/goods/Goods";
import GoodsCategory from "store/productPayment/category/GoodsCategory";

/**
 * 상품
 */
export function getGoodsMain(params: { shopid: string }) {
  return axios
    .request<{ goodsList: Array<Goods>; shopTID: string; }>({
      url: `${SERVER_URL}/goods/list`,
      method: "GET",
      headers: getHeader(),
      params,
    })
    .then((response) => (response.status === 200 ? response.data : { goodsList: [], shopTID: '' }));
}

/**
 * 상품 카테고리
 */
export function getGoodsCate() {
  return axios
    .request<Array<GoodsCategory>>({
      url: `${SERVER_URL}/goods/cate`,
      method: "GET",
      headers: getHeader(),
    })
    .then((response) => (response.status === 200 ? response.data : []));
}
